export const i18nextNamespaceAiTools = 'aiTools';
